import { Box, Heading } from "@radix-ui/themes";
import React from "react";
import Chart from "react-apexcharts";
import { useChartTheme } from "../../../hooks/useChartTheme";
import { CriteriaScoreType } from "../../../types/TeacherEvaluation";

const CriteriaScoresTable = ({ data }: { data: CriteriaScoreType[] }) => {
  const { withTheme } = useChartTheme();
  const criteriaAverage = data.reduce((acc, curr) => {
    acc[curr.criterio] = (acc[curr.criterio] || []).concat(curr.score);
    return acc;
  }, {} as Record<string, number[]>);

  const averageScores = Object.entries(criteriaAverage).map(([criterio, scores]) => ({
    criterio,
    average: parseFloat((scores.reduce((sum, score) => sum + score, 0) / scores.length).toFixed(2)), // Média com 2 casas decimais
  }));

  const barChartData = {
    series: [
      {
        name: "Média",
        data: averageScores.map((item) => item.average),
      },
    ],
    options: {
      chart: { type: "bar" as const },
      xaxis: { categories: averageScores.map((item) => item.criterio) },
      title: { text: "Média das Pontuações por Critério (Barra)" },
    },
  };

  const pieChartData = {
    series: averageScores.map((item) => item.average),
    options: {
      chart: { type: "pie" as const },
      labels: averageScores.map((item) => item.criterio),
      title: { text: "Média das Pontuações por Critério (Circular)" },
      tooltip: {
        y: {
          formatter: (value: number) => value.toFixed(2), // Formata o tooltip com 2 casas decimais
        },
      },
      dataLabels: {
        formatter: (value: number) => value.toFixed(2), // Formata os labels com 2 casas decimais
      },
    },
  };

  return (
    <Box>
      <Heading as="h3" size="3" weight="bold">Pontuações por Critérios</Heading>

      {/* Gráfico de Barras */}
      <Box mt="4">
        <Heading as="h4" size="2" weight="medium" mb="2">Gráfico de Barras</Heading>
        <Chart options={withTheme(barChartData.options)} series={barChartData.series} type="bar" height={350} />
      </Box>

      {/* Gráfico Circular */}
      <Box mt="4">
        <Heading as="h4" size="2" weight="medium" mb="2">Gráfico Circular</Heading>
        <Chart options={withTheme(pieChartData.options)} series={pieChartData.series} type="pie" height={350} />
      </Box>
    </Box>
  );
};

export default CriteriaScoresTable;
